import { overlapRatio } from './sourceEditPolicy.js';

/** Find a compact, connected cluster of PDF paint/text rectangles.
 * Ignore huge page-covering background bitmaps: otherwise selecting a badge
 * would capture an entire cover. This is only a *visual group proposal*.
 */
export function proposeCompositeGroup(target, images = [], texts = [], bounds) {
  if (!target) return null;
  let group={x:target.x,y:target.y,width:target.width,height:target.height};
  const area=bounds.width*bounds.height;
  const candidates=[...images,...texts].filter(x=>x.id!==target.id && x.width*x.height<area*.4);
  const added=new Set();
  for(let pass=0;pass<4;pass++) {
    let grew=false;
    for(let i=0;i<candidates.length;i++) {
      if (added.has(i)) continue;
      const x=candidates[i];
      if (overlapRatio(group,x)<.07) continue;
      const left=Math.min(group.x,x.x),top=Math.min(group.y,x.y);
      const right=Math.max(group.x+group.width,x.x+x.width);
      const bottom=Math.max(group.y+group.height,x.y+x.height);
      const next={x:left,y:top,width:right-left,height:bottom-top};
      // Prevent cascading through long lines or nearly-full-page photos.
      if(next.width*next.height>area*.33) continue;
      group=next;added.add(i);grew=true;
    }
    if(!grew) break;
  }
  // A narrow margin makes the background around round badges/logos visible;
  // without it the bounding box can touch coloured pixels on all four sides,
  // preventing safe flat-backdrop identification.
  const pad=Math.min(9,Math.max(3,Math.min(group.width,group.height)*.06));
  const x=Math.max(0,group.x-pad), y=Math.max(0,group.y-pad);
  const right=Math.min(bounds.width,group.x+group.width+pad);
  const bottom=Math.min(bounds.height,group.y+group.height+pad);
  return {x,y,width:right-x,height:bottom-y};
}
